// Importing Vendor SASS File
import "../scss/vendors/vendor.scss";


import "bootstrap";
import "@fortawesome/fontawesome-free";
import "slick-carousel";


(function ($) {
  "use strict";
  // Slick JS Settings
  $(".slick-items-wrapper").slick({
    infinite: true,
    autoplay: true,
    dots: true,
    arrows: true,
    speed: 1200,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          centerMode: false,
          centerPadding: "50px",
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
          arrows: true,
        },
      },

      {
        breakpoint: 768,
        settings: {
          centerMode: false,
          centerPadding: "30px",
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
          arrows: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          centerMode: false,
          centerPadding: "30px",
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
          arrows: true,
        },
      },
    ],
  });
})(jQuery);
